import { render, staticRenderFns } from "./BDROneCdictionary.vue?vue&type=template&id=7fb77fb2&"
import script from "./BDROneCdictionary.vue?vue&type=script&lang=js&"
export * from "./BDROneCdictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports